import { spanishMovies, spanishMoviesForEnUs } from '../data/spanishMovies/spanishMovies.data';
import { MoviesTagPageContent } from '../MoviesTagPageContent';
import { TagPageProps } from '../types/tagPageProps';

export const Content = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={spanishMovies} />
);

export const ContentEnUs = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={spanishMoviesForEnUs} />
);
